<template>
    <v-flex xs12 v-observe-visibility="visibilityChanged">
        <v-flex xs12 pa-3>
            <v-layout row wrap pb-2>
                <v-subheader>Process History</v-subheader>
                <v-switch color="secondary" class="header-switch" v-model="showSnapshots" label=""></v-switch>
            </v-layout>
            <v-divider></v-divider>

        </v-flex>

        <v-flex xs12 md12 pl-3 pr-3>
            <FakeTable v-show="loadingHistory">
            </FakeTable>
            <v-list three-line v-show="!loadingHistory">
                <template v-for="(item, index) in filterItems">

                    <v-list-tile
                            avatar
                            @click="showMessage(item)"
                    >
                        <v-list-tile-avatar>
                            <v-icon>fas fa-user</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <div class="process-history">{{item.created_at | toDateTimeLocalTime}}</div>
                            <v-list-tile-title><span class='text--primary'>{{item.account.firstname}} {{item.account.lastname}}</span>
                                - {{item.histories_type.name}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title
                                    v-html="item.subtitle"></v-list-tile-sub-title>
                            <i v-if="item.snapshot" class="fas fa-history process-history-icon"></i>
                            <i v-if="!item.snapshot" class="fas fa-comment-alt-lines process-history-icon"></i>

                        </v-list-tile-content>
                    </v-list-tile>
                    <v-flex xs11 offset-xs1 offset-md1 offset-lg1 v-show="item.show_message">
                        <v-list-tile-sub-title
                                v-if="!item.snapshot">Message:
                        </v-list-tile-sub-title>

                        <v-textarea v-if="!item.snapshot"
                                    solo
                                    flat
                                    auto-grow
                                    label="No message"
                                    rows="3"
                                    v-model="item.message"
                                    readonly
                        ></v-textarea>

                        <v-list-tile-sub-title
                                v-if="item.snapshot">Changed Data:
                        </v-list-tile-sub-title>
                        <div class="diffView" v-if="item.snapshot" v-html="returnDiff(item)"></div>
                    </v-flex>
                    <v-divider :inset="true"
                    ></v-divider>
                </template>
                <v-flex v-if="items.length === 0" xs12>
                    <div class='text--secondary text-xs-center'>No history data</div>
                </v-flex>
            </v-list>

                 <v-layout row wrap v-show="!loadingHistory" pl-3 pr-3>

                    <v-flex xs12 >
                        <v-textarea
                                solo
                                flat
                                auto-grow
                                label="Enter new message"
                                rows="2"
                                v-model="newHistoryMessage"
                        ></v-textarea>
                    </v-flex>

                    <v-flex xs12 pb-3>
                        <emoji-picker @emoji="insert" :search="search">
                            <div
                                    class="emoji-invoker"
                                    slot="emoji-invoker"
                                    slot-scope="{ events: { click: clickEvent } }"
                                    @click.stop="clickEvent"
                            >
                                <v-icon style="float: left; margin-left: 8px; margin-top: 8px" color="grey">fas fa-smile-beam</v-icon>
                            </div>
                            <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
                                <div class="emoji-picker" :style="{ bottom: -8 + 'px', left: 0 + 'px' }">

                                    <div class="emoji-picker__search">
                                        <!--   <input type="text" v-model="search" v-focus>-->
                                       <!-- <input type="text" v-model="search">-->
                                        <v-text-field clearable
                                                      v-model="search"
                                                      label="Search"
                                        ></v-text-field>
                                    </div>
                                    <div>
                                        <div v-for="(emojiGroup, category) in emojis" :key="category">
                                            <h5>{{ category }}</h5>
                                            <div class="emojis">
                <span
                        v-for="(emoji, emojiName) in emojiGroup"
                        :key="emojiName"
                        @click="insert(emoji)"
                        :title="emojiName"
                >{{ emoji }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </emoji-picker>

                    </v-flex>
                </v-layout>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :loading="saveMessage" small flat dark color="secondary" @click.native="saveHistoryItem()">
                        leave message
                        <v-icon right>send</v-icon>
                    </v-btn>
                </v-card-actions>
                <v-divider></v-divider>
            </v-flex>
        </v-flex>
</template>

<script>
    /*  import {API_URL} from '../../store/index' */

    import FakeTable from '../Shared/FakeTable.vue'

    import {DiffPatcher, formatters} from 'vue-jsondiffpatch'

    import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'

    import EmojiPicker from 'vue-emoji-picker'

    import {
        History
    } from '../../store/namespace-helper'

    export default {
      components: {
        FakeTable,
        EmojiPicker
      },
      mixins: [dateFunctionFilters],
      name: 'v-process-history',
      model: {
        prop: 'messageStream',
        event: 'change'
      },
      props: {
        historyTypeID: {
          type: Number,
          default: null
        },
        itemID: {
          type: Number,
          default: null
        },
        selectedItem: {
          type: Object,
          default: null
        }
      },
      data () {
        return {
          items: [],
          loadingHistory: true,
          newHistoryMessage: '',
          isVisible: false,
          saveMessage: false,
          showSnapshots: false,
          emojiMenu: false,
          search: '',
          clickEvent: false
        }
      },
      created () {
      },
      computed: {
        filterItems () {
          return this.items.filter(item => {
            if (item.snapshot) {
              if (this.showSnapshots) {
                return item
              }
            } else {
              return item
            }
          })
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
                        // this.loadItems()
            } else {
            }
          }
        },
        returnDiff (item) {
          let diffPatcher = new DiffPatcher()
          var delta = diffPatcher.diff(JSON.parse(item.data), this.selectedItem)
          let html = formatters.html.format(delta, this.selectedItem)
          formatters.html.hideUnchanged()
          return html
        },
        loadItems () {
          this.loadingHistory = true
          this.$store.dispatch(History.actions.loadHistories, {
            id: this.itemID,
            histories_types_id: this.historyTypeID
          }).then(response => {
            this.$emit('change', response.data)
            this.loadingHistory = false
            this.items = response.data.data
            console.log('history items: ')
            console.log(this.items)
          })
        },
        saveHistoryItem () {
          this.saveMessage = true
          this.$store.dispatch(History.actions.saveHistory, {
            items_id: this.itemID,
            histories_types_id: this.historyTypeID,
            subtitle: 'Left message',
            message: this.newHistoryMessage,
            show_message: true
          }).then(response => {
            this.newHistoryMessage = ''
            this.saveMessage = false
            this.loadItems()
          })
        },
        showMessage (item) {
          item.show_message = !item.show_message
        },
        insert (emoji) {
          this.newHistoryMessage += emoji
        }
      },
      watch: {
        selectedItem: {
          handler (val) {
            this.loadItems()
          },
          deep: true

        }
      }

    }
</script>


<style scoped>

    .process-history {
        /*        position: absolute;*/
        padding-top: 4px;
        text-align: right;
        width: 100%;
        font-size: 0.95rem;
    }

    .process-history-icon {
        position: absolute;
        text-align: right;
        width: 100%;
        padding-bottom: 8px;
        padding-right: 16px;
        padding-top: 8px;
        font-size: 1.0rem;
        bottom: 0;
        right: 0;
    }

    .diffView {
        width: 100%;

        overflow: hidden;
        overflow-x: scroll;
        padding-bottom: 32px;
    }

    .header-switch {
        position: absolute;
        right: 24px;
    }

/*    .wrapper {
        position: relative;
        display: inline-block;
    }*/

    .emoji-picker {
        position: relative;
        z-index: 1000;
/*        border: 1px solid #ccc;*/
        width: 100%;
        height: 20rem;
        overflow: scroll;
  /*      padding: 1rem;*/
        box-sizing: border-box;
/*        border-radius: 3px;*/
        background: #fff;
/*        box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2);*/
/*        bottom: 25%;
        right: 10px;*/
    }
    .emoji-picker__search {
        display: flex;
    }
    .emoji-picker__search > input {
        flex: 1;
        border-radius: 3px;
        border: 1px solid #ccc;
        padding: 0.5rem 1rem;
        outline: none;
    }
    .emoji-picker h5 {
        margin-bottom: 0;
        color: rgba(0, 0, 0, 0.65);
        text-transform: uppercase;
        font-size: 0.9rem;
        cursor: default;
        font-weight: 500;
    }
    .emoji-picker .emojis {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .emoji-picker .emojis:after {
        content: "";
        flex: auto;
    }
    .emoji-picker .emojis span {
        padding: 0.3rem;
        cursor: pointer;
        border-radius: 3px;
        font-size: 2.0rem;
    }
    .emoji-picker .emojis span:hover {
        background: #ececec;
        cursor: pointer;
    }


</style>



// WEBPACK FOOTER //
// src/components/Shared/ProcessHistory.vue